var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10059",
    "data-name": "Group 10059",
    transform: "translate(-960 -563)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_573",
    "data-name": "Ellipse 573",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(960 563)",
    fill: "#098817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "video-svgrepo-com-3",
    d: "M23.615,5.466c-1.456-.522-4.719,1.322-7.085,3.64a5.156,5.156,0,0,0-4.853-5.1H6.824A5.229,5.229,0,0,0,1.971,9.554v8.31a5.241,5.241,0,0,0,4.853,5.557h4.853a5.168,5.168,0,0,0,4.853-5.108c2.366,2.305,5.629,4.149,7.085,3.64,2.269-.813,2.657-5.168,2.657-8.225S25.883,6.279,23.615,5.466Z",
    transform: "translate(972.883 576.285)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoChecked);
export default __webpack_public_path__ + "static/media/video-checked.4fdbf9566adccc0ee5250c2f7a736b0f.svg";
export { ForwardRef as ReactComponent };